/* eslint-disable no-console */
import React from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/**
 * For a Teams event:
 * - We treat all weeks as one group called "teams"
 * - The "generateTeamsDraw" might store them in `weeks[]`.
 * - This component just loops through each "weekDraw", but
 *   **only** displays one line per **unique** "Team vs Team" pairing.
 */
export default function TeamsDraw({
  groupedWeeks, // e.g. { teams: [...] }
  handleOpenScoreSheet,
  handleOpenPrintableScoreSheet,
}) {
  if (!groupedWeeks || !groupedWeeks.teams) {
    return <Typography>No Teams draws found.</Typography>;
  }

  const weeksArray = groupedWeeks.teams; // just one array

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>TEAMS</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Week</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Matches (Team vs Team)</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {weeksArray.map((weekDraw, idx) => {
                // Gather a set of unique pairs from weekDraw.matches
                const uniquePairs = new Set();

                weekDraw.matches.forEach((m) => {
                  const pairName = `${m.team1TeamName} vs ${m.team2TeamName}`;
                  uniquePairs.add(pairName);
                });

                // Convert that set back to an array
                const uniquePairArray = Array.from(uniquePairs);

                return (
                  <TableRow key={idx}>
                    <TableCell>{weekDraw.week}</TableCell>
                    <TableCell>{weekDraw.date}</TableCell>
                    <TableCell>
                      {uniquePairArray.map((pair, i2) => (
                        <Typography key={i2}>{pair}</Typography>
                      ))}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        onClick={() => handleOpenScoreSheet(weekDraw)}
                      >
                        Add/Update Scores
                      </Button>
                      <Button
                        variant="outlined"
                        sx={{ ml: 1 }}
                        onClick={() => handleOpenPrintableScoreSheet(weekDraw)}
                      >
                        Printable Score Sheet
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
}

TeamsDraw.propTypes = {
  groupedWeeks: PropTypes.object,
  handleOpenScoreSheet: PropTypes.func.isRequired,
  handleOpenPrintableScoreSheet: PropTypes.func.isRequired,
};
